import team1 from '../assets/team1.jpeg'
import team2 from '../assets/team2.jpeg'
import team3 from '../assets/team3.jpeg'
import team4 from '../assets/team4.jpeg'
import team5 from '../assets/team5.jpeg'
import team6 from '../assets/team6.jpeg'
import team7 from '../assets/team7.jpeg'


const TeamData = [
    {
        img: team1,
       text: 'Subin'
    },
    {
        img: team2,
        text: 'Rashwin'
    }
    ,
    {
        img: team3,
        text: 'Jerlin'
    }
    
    ,
    {
        img: team4,
        text: 'Deno'

    }
    ,
    {
        img: team5,
       text: 'Abisanth'
    }
    ,
    {
        img: team6,
        text: 'Rahul'
    }
    ,
    {
        img: team7,
        
    }
]

export default TeamData;